export default "__VITE_ASSET__d9de3dc3__"